/**
 * Applies locale-aware decimal separator to a number string.
 * Replaces period (.) with comma (,) for French and Portuguese locales.
 *
 * @param {string} numberString - The number string to format (e.g., "44.2")
 * @returns {string} - The formatted string with appropriate decimal separator
 */
export default (numberString) => {
  if (!numberString || typeof numberString !== 'string') {
    return numberString;
  }

  // Check if the string contains a decimal point
  if (numberString.indexOf('.') === -1) {
    return numberString;
  }

  // Determine if we're in French or Portuguese locale
  let isFRorPT = false;

  if (typeof window !== 'undefined') {
    // Check window.active_language first (set by i18n languageChanged event)
    if (window.active_language === 2 || window.active_language === 4) {
      isFRorPT = true;
    } else if (window.localStorage) {
      // Fallback to localStorage
      const storedLang = window.localStorage.getItem('i18nextLng');
      if (storedLang === 'fr' || storedLang === 'pt') {
        isFRorPT = true;
      }
    }
  }

  // For legacy JavaScript context (when active_language is available globally)
  // This handles cases where the function is called from legacy code
  if (typeof active_language !== 'undefined') {
    if (active_language === 2 || active_language === 4) {
      isFRorPT = true;
    }
  }

  // Replace decimal separator for French and Portuguese
  if (isFRorPT) {
    return numberString.replace('.', ',');
  }

  return numberString;
};
